export default __webpack_public_path__ + "12c4152e5a03c58a302fe17e4789306a.jpg";